module.exports = __webpack_public_path__ + "img/compute_icon.98c7d6bb.png";